import { EmptyElements, EmptyStateContainer } from "./Styles";
import { MascotFeedback, MascotSize, MascotVariant } from "../MascotFeedback";

interface EmptyStateProps {
    message: string;
    mascotVariant: MascotVariant;
    mascotSize?: MascotSize;
    dropShadow?: "none" | "glow";
}

export const EmptyState = ({ message, mascotVariant, mascotSize = "lg", dropShadow = "none" }: EmptyStateProps) => {
    return (
        <EmptyStateContainer>
            <EmptyElements>
                <MascotFeedback
                    variant={mascotVariant}
                    name="cloud"
                    decorative
                    size={mascotSize}
                    dropShadow={dropShadow}
                />
                <p>{message}</p>
            </EmptyElements>
        </EmptyStateContainer>
    );
};